import HeaderBreakdown from './HeaderBreakdown/HeaderBreakdown'
import HeaderDefault from './HeaderDefault/HeaderDefault'
// TODO: deprecate old HeaderDetails
import HeaderDetails from './HeaderDetails/HeaderDetails'
import Header from './Header'
import HeaderBreakdownToggle from './HeaderBreakdownToggle'
import HeaderProfileToggles from './HeaderProfileToggles'

export {
  HeaderBreakdown,
  HeaderDefault,
  HeaderDetails,
  HeaderBreakdownToggle,
  HeaderProfileToggles
}

export default Header
